export default "__VITE_ASSET__CZPbkCmw__"